import * as type from "../mutation-types";
import AES from "@/mixins/AES";
import { getEnvironmentAssets } from "@/plugins/environment"; // 引入环境变量
const state = {
  token: window.localStorage.getItem("token") || "",
  MenuList: window.localStorage.getItem("menuList"),
};
const getters = {
  getToken: (state) => state.token,
  getMenuList: (state) => state.menuList,
};

const mutations = {
  [type.USER_LOGIN_SUCCESS](state, response) {
    state.token = response.return_token;
    state.MenuList = response.menuList;
  },
  [type.USER_OUT_LOGIN](state) {
    state.token = null;
    state.MenuList = null;
  },
};

const actions = {
  onLogin({ commit }, response) {
    commit(type.USER_LOGIN_SUCCESS, response);
    let token = `Bearer ${response.token}`;
    window.localStorage.setItem("token", token);
    window.localStorage.setItem(
      "menuList",
      AES.encrypt(JSON.stringify(response.role[0].children))
    );
    window.localStorage.setItem("server", response.server);
    window.localStorage.setItem(
      "isSignContract",
      response &&
        response.contract &&
        response.contract.isSignContract !== undefined &&
        response.contract.isSignContract !== null
        ? JSON.stringify(response.contract.isSignContract)
        : ""
    );
    window.localStorage.setItem(
      "deadlineTime",
      response &&
        response.contract &&
        response.contract.deadlineTime !== undefined &&
        response.contract.deadlineTime !== null
        ? response.contract.deadlineTime
        : ""
    );
  },
  outLogin({ commit }) {
    commit(type.USER_OUT_LOGIN);
    window.document.title = getEnvironmentAssets("title");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("menuList");
    window.localStorage.removeItem("isSignContract");
    window.localStorage.removeItem("deadlineTime");
    window.localStorage.setItem("windowTitle", getEnvironmentAssets("title"));
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
